<template>
    <div class='head-box'>
        <div class='logo-box'>
            <div class="icon-wrapper" @mouseenter="togShow(true)" ><img class="menu-icon" :src="menuIconUrl"/></div>
            <div class='logo'><a href='/index'>{{logoname}}</a></div>
            <ul class='header-bar-ul'>
                <li><a title='V0.1beta'>版本</a></li>
                <li><a @click="addFavorite">加入收藏</a></li>
                <li><a href='/account/accountCenter'>个人中心</a></li>
                <!-- <li><a href='/manage/mywork'>我的工作</a></li> -->
                <li v-if='logined'><span class='l-pad'>
                        <Icon type="ios-contact" /></span><span class='l-pad'>已登录</span><span class='l-pad logout-pad' @click='logout'>退出</span></li>
                <li v-else>您好，<a href='/login'>请登录</a><a href='/register' class='l-pad'>注册</a></li>
                <li><a href="/index"><Icon type="ios-home-outline" />&nbsp;返回主页</a></li>
            </ul>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'headerBar',
        data() {
            return {
                logined: false,
                account: '12345678956',
                menuIconUrl: process.env.BASE_URL + "img/menuIcon.png",
            }
        },
        props: {
            logoname: {
                type: String,
                default: "上海赛恩工贸有限公司信息系统"
            },
        },
        created() {
            let userToken = localStorage.getItem("current_user_token");
            if (userToken !== undefined && userToken !== null) {
                this.logined = true;
            }
        },
        methods: {
            addFavorite: function () {
                let url = window.location;
                let title = document.title;
                let ua = navigator.userAgent.toLowerCase();
                if (ua.indexOf("360se") > -1) {
                    alert("由于360浏览器功能限制，请按 Ctrl+D 手动收藏！");
                }
                else if (ua.indexOf("msie 8") > -1) {
                    window.external.AddToFavoritesBar(url, title); //IE8
                }
                else if (document.all) {
                    try {
                        window.external.addFavorite(url, title);

                    } catch (e) {
                        alert('您的浏览器不支持,请按 Ctrl+D 手动收藏!');
                    }
                } else if (window.sidebar) {
                    window.sidebar.addPanel(title, url, "");
                } else {
                    alert('您的浏览器不支持,请按 Ctrl+D 手动收藏!');
                }
            },
            logout: function () {
                localStorage.clear();
                this.logined = false;
                location.href = "/system_login";
            },
            togShow:function(value){
                this.$emit('menuToggle',value)
            }
        }
    }
</script>

<style scoped>
    body {
        padding: 0;
        margin: 0;
    }

    a {
        text-decoration: none;
        color: inherit;
    }

    a:visited {
        text-decoration: none;
    }

    a:hover {
        text-decoration: none;
        color:inherit;
    }

    span {
        cursor: pointer;
    }

    .head-box {
        width: 100%;
        height: 38px;
        background: rgb(34, 34, 54);
        color: rgb(176, 176, 176);
        min-width: 1260px;
    }

    .logo-box {
        width: 100%;
        margin: 0 auto;
    }

    .logo {
        float: left;
        font-size: 12px;
        line-height: 40px;
        margin-left:50px; 
    }
    .logo:hover{
        color:#ffffff;
    }

    .header-bar-ul {
        float: right;
        width: auto;
        height: 36px;
        line-height: 36px;
        margin: 0;
        padding: 0;
    }

    .header-bar-ul>li {
        margin-top: 12px;
        float: right;
        line-height: 12px;
        font-size: 12px;
        list-style: none;
        padding: 0 1em;
        height: 12px;
        border-right: solid 1px rgb(176, 176, 176);
    }

    .header-bar-ul>li:hover a {
        color: #eee;
    }

    li:first-child {
        border-right: none;
    }

    .l-pad {
        padding-left: 1em;
        cursor: default;
    }

    .logout-pad:hover{
        color:#fff;
        cursor: pointer;
        
    }

    .high-light {
        color: #ffffff;
    }
    .icon-wrapper{
        padding-top:12px; 
        float: left;
        padding-left:12px; 
    }
    .menu-icon{
        width:18px;
    }
</style>